$(document).ready(function () {
  // Configurações comuns
  const commonSettings = {
    infinite: false,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    prevArrow:
      '<button type="button" aria-label="Anterior" class="slick-prev"><i class="fas fa-chevron-left"></i></button>',
    nextArrow:
      '<button type="button" aria-label="Próximo" class="slick-next"><i class="fas fa-chevron-right"></i></button>',
    mobileFirst: false,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  // Lista apenas os sliders que existem na página
  function getExistingSliders() {
    const allSliders = [
      ".mais-acessados",
      ".rowRecentesHome",
      ".rowEstadosHome",
      ".rowInternacionalHome",
      ".rowDocumentacaoHome",
      ".rowGuiaHome",
      ".rowTurismoHome",
      ".rowpaises.europa",
      ".rowpaises.america-do-norte",
      ".rowpaises.america-do-sul",
      ".rowpaises.asia",
      ".rowpaises.africa",
      ".rowpaises.oceania",
      ".rowpaises.oriente-medio",
    ];

    return allSliders.filter((selector) => $(selector).length > 0);
  }

  // Configurações específicas para sliders existentes
  const sliderConfigs = {
    ".mais-acessados": { slidesToShow: 2 },
    ".rowRecentesHome": { slidesToShow: 3 },
    ".rowEstadosHome": { slidesToShow: 4 },
    ".rowInternacionalHome": { slidesToShow: 4 },
    ".rowDocumentacaoHome": { slidesToShow: 3 },
    ".rowGuiaHome": { slidesToShow: 4 },
    ".rowTurismoHome": { slidesToShow: 4 },
    ".rowpaises.europa": { slidesToShow: 4 },
    ".rowpaises.america-do-norte": { slidesToShow: 3 },
    ".rowpaises.america-do-sul": { slidesToShow: 4 },
    ".rowpaises.asia": { slidesToShow: 4 },
    ".rowpaises.africa": { slidesToShow: 4 },
    ".rowpaises.oceania": { slidesToShow: 2 },
    ".rowpaises.oriente-medio": { slidesToShow: 4 },
  };

  // Inicializa apenas sliders existentes
  function initializeExistingSliders() {
    const existingSliders = getExistingSliders();

    existingSliders.forEach((selector) => {
      try {
        const settings = {
          ...commonSettings,
          ...sliderConfigs[selector],
        };

        $(selector).slick(settings);
      } catch (error) {}
    });
  }

  // Aguarda todos os recursos carregarem
  setTimeout(initializeExistingSliders, 300);
});



// WEBPACK FOOTER //
// ./scripts/routes/slider.js